import { Spin } from 'antd';
import Styles from './assets/style.scss';
import IProps from './entities/IProps';

const BCLoading = (props: IProps) => {
	return (
		<div
			className={
				'loadingOverlay ' +
				Styles.loadingOverlay +
				(props.show ? ' ' + Styles.show : '') +
				(props.center ? ' ' + Styles.center : '') +
				' ' +
				(props.overlayClassName ?? '')
			}
		>
			<Spin
				size={props.size}
				delay={props.delay}
				className={props.className}
				spinning={!!props.show}
				style={props.style}
			>
				{props.children}
			</Spin>
		</div>
	);
};
export default BCLoading;
export { IProps };
